import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'src/app/share-module';
import { ComponentsModule } from 'src/app/components/components-module';
import { AccountComponent } from './account.component';
import { BillingHistoryComponent } from './billing-history/billing-history.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ChangePasswordRouteComponent } from './change-password-route/change-password-route.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { ActivateCouponComponent } from './activate-coupon/activate-coupon.component';
import { UpdateSubscriberInfoRouteComponent } from './update-subscriber-info-route/update-subscriber-info-route.component';

@NgModule({
    imports: [
        CommonModule,
        ShareModule,
        ComponentsModule
    ],
    declarations: [
        AccountComponent,
        BillingHistoryComponent,
        ChangeEmailComponent,
        ChangePasswordRouteComponent,
        SubscriptionsComponent,
        ActivateCouponComponent,
        UpdateSubscriberInfoRouteComponent
    ]
})

export class AccountModule { }